const e = {
  100: {
    color: "text-yellow"
  },
  200: {
    color: "text-green"
  },
  202: {
    color: "text-green"
  },
  300: {
    color: "text-blue"
  },
  304: {
    color: "text-blue"
  },
  400: {
    color: "text-red"
  },
  401: {
    color: "text-orange"
  },
  422: {
    color: "text-yellow"
  },
  423: {
    color: "text-purple"
  },
  505: {
    color: "text-orange"
  }
}, r = (o) => e[o] || {
  /** default color */
  color: "text-grey"
};
export {
  e as STATUS_CODES_COLORS,
  r as getStatusCodeColor
};
